/* BAUMSTEIN — global behaviours shared by all bs-* sections.
   Section-specific JS lives inline in each section file; this file only carries
   what must survive across sections: the scroll-reveal observer.
   Editor-safe: re-inits on shopify:section:load without double-binding. */
(function () {
  'use strict';

  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('.reveal:not(.is-visible):not([data-bs-observed])');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '-60px 0px', threshold: 0.08 });
    els.forEach(function (el) {
      el.setAttribute('data-bs-observed', '');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveals(document); });
  } else {
    initReveals(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });

  window.bsInitReveals = initReveals;
})();
